export var MINIMAL_VALUE = 'minimal value';
export var TARGET_VALUE = 'target value';
